import { useMutation, useQueryClient } from "@tanstack/react-query";

import { resetModelOverride } from "./api";
import type { Role } from "./api";

// Откат модели роли к default_model (DELETE
// /agent_roles/{role}/model). Идемпотентно на backend. На успех
// инвалидируем весь префикс `agent-roles` — detail роли (effective_model
// = default) и общая история override'ов (новая строка отката)
// перечитаются. Ошибку (404 нет роли) пробрасываем для тоста.
export function useResetModelOverride(): ReturnType<
  typeof useMutation<Role, Error, string>
> {
  const queryClient = useQueryClient();
  return useMutation<Role, Error, string>({
    mutationFn: (roleName) => resetModelOverride(roleName),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["agent-roles"] });
    },
  });
}
